<template>
  <div class="transaction-person-component d-flex align-center">
    <avatar
      v-if="transaction"
      class="person-avatar mr-3"
      :user="transaction.sender"
      :border="false"
    />
    <div v-else class="transaction-person-avatar"></div>
    <div class="person-info">
      <span class="status">Курьер</span>
      <span class="name">{{ getCourierName }}</span>
      <!--      <span class="amount font-weight-medium">16000₽</span>-->
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/administrator/work-shift/staff/Avatar.vue'

  export default {
    name: 'TransactionPerson',
    components: { Avatar },
    props: {
      person: {
        type: Object,
        default: () => ({}),
      },
      transaction: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      getCourierName () {
        try {
          return `${this.transaction.sender.firstName} ${this.transaction.sender.lastName}`
        } catch {
          return ''
        }
      },
    },
  }
</script>

<style lang="less" scoped>
.transaction-person-component {
  flex: 1;

  .person-info {
    span {
      display: block;
    }

    .status {
      font-size: 16px;
      line-height: 1;
      margin-bottom: 3px;
    }

    .name {
      font-size: 29px;
      line-height: 38px;
    }

    .amount {
      font-size: 20px;
      line-height: 37px;
    }
  }
}

.person-avatar {
  width: 70px;
  height: 70px;
}

.transaction-person-avatar {
  width: 93px;
  height: 93px;
  background-color: @color-primary;
  border-radius: 50%;
  margin-right: 15px;
  flex-shrink: 0;
}
</style>
